import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/Entitlements';

export interface IEntitlement {
  name: string;
  activation: string;
  automatic: boolean;
  category: string;
  contact: string;
  critereaDesc: string[];
  entitlementTypeId: number;
  extraCriteria: string;
  fullExplanation: string;
  insertDate: Date;
  instruction: string;
  oneTime: boolean;
  shortExplanation: string;
  subCategory: string;
  subSubject: number;
  subject: number;
  upDateDate: Date;
  lastDateTimeUsed: Date;
  OtherCriteriaUrl?: string;
  eligibleFrequency: string;
}

export const getEntitlements = async () => {
  const entitlements = await api.get<{
    userEntitlements: IEntitlement[];
    lastUpdateDate: Date;
  }>(addImposterToUrl(baseURL, true));
  if (entitlements) return entitlements;
};

export const getEntitlementByID = async (id: string) => {
  const entitlement = await api.get(addImposterToUrl(`${baseURL}/${id}`, true));
  if (entitlement.data) return entitlement.data;
};

export const getCategories = async () => {
  const categories = await api.get(
    addImposterToUrl(`${baseURL}/Categories`, true)
  );
  if (categories.data) return categories.data;
};

export const legalApproval = async () => {
  await api.post(addImposterToUrl(`${baseURL}/approvals`, true));
};

export const getIsApproved = async () => {
  const isApproved = await api.get(
    addImposterToUrl(`${baseURL}/Approvals/IsApproved`, true)
  );
  if (isApproved.data) return isApproved.data;
};
